import React, { useEffect, useRef, useState } from "react";
import { loadMapSdk, createProviderMap } from "./map_providers";

const MAP_PROVIDER =
  process.env.REACT_APP_MAP_PROVIDER || process.env.VITE_MAP_PROVIDER || "neshan";

const OrderMap = ({ lat, lng }) => {
  const mapContainerRef = useRef(null);
  const mapRef = useRef(null);
  const [mapReady, setMapReady] = useState(false);

  useEffect(() => {
    if (!lat || !lng) return;

    let isMounted = true;

    loadMapSdk().then((L) => {
      if (!isMounted || !mapContainerRef.current) return;

      const map = createProviderMap(L, mapContainerRef.current, {
        lat,
        lng,
        zoom: 15,
        provider: MAP_PROVIDER,
        mapOptions: {
          dragging: true,
          scrollWheelZoom: true,
          doubleClickZoom: true,
          zoomControl: true,
        },
      });

      L.marker([lat, lng]).addTo(map);

      mapRef.current = map;
      setMapReady(true);

      setTimeout(() => {
        map.invalidateSize();
      }, 200);
    });

    return () => {
      isMounted = false;
      if (mapRef.current) {
        mapRef.current.remove();
        mapRef.current = null;
        setMapReady(false);
      }
    };
  }, [lat, lng]);

  if (!lat || !lng) return null;

  return (
    <div
      ref={mapContainerRef}
      style={{
        width: "100%",
        height: 200,
        borderRadius: 8,
        overflow: "hidden",
        marginTop: 8,
      }}
    />
  );
};

export default OrderMap;